import { Link, useLocation } from "react-router-dom";
import {
  SignInButton,
  SignedIn,
  SignedOut,
  UserButton,
} from "@clerk/clerk-react";

export default function Navbar() {
  const { pathname } = useLocation();

  const logoContent = (
    <>
      <img src="/images/easyreports_logo.png" alt="EasyReports logo" style={{ height: 28, width: 28, objectFit: "contain" }} />
      EasyReports
    </>
  );

  return (
    <header className="public-navbar">
      <SignedOut>
        <Link to="/" className="public-navbar-logo">{logoContent}</Link>
      </SignedOut>
      <SignedIn>
        <Link to="/dashboard" className="public-navbar-logo">{logoContent}</Link>
      </SignedIn>

      <div className="public-navbar-actions">
        <nav className="public-navbar-links">
          <Link to="/"        className={`public-navbar-link${pathname === "/"        ? " active" : ""}`}>Home</Link>
          <Link to="/pricing" className={`public-navbar-link${pathname === "/pricing" ? " active" : ""}`}>Pricing</Link>
          <Link to="/about"   className={`public-navbar-link${pathname === "/about"   ? " active" : ""}`}>About</Link>
          <Link to="/contact" className={`public-navbar-link${pathname === "/contact" ? " active" : ""}`}>Contact</Link>
        </nav>
        <SignedOut>
          <SignInButton mode="modal" afterSignInUrl="/dashboard" afterSignUpUrl="/dashboard">
            <button className="nav-signin-btn">Sign in</button>
          </SignInButton>
        </SignedOut>
        <SignedIn>
          <Link to="/dashboard">
            <button className="nav-dashboard-btn">Dashboard</button>
          </Link>
          <UserButton afterSignOutUrl="/" />
        </SignedIn>
      </div>
    </header>
  );
}
